import {IComponentOptions, ILogService} from "angular";
import "./application-documents.less";
import {getSecureDownloadUrl} from "../../../shared/utils/attachment-utils";

class ApplicationDocumentsController {

    public application;
    public attachments = [];

    /* @ngInject */
    constructor(private $log: ILogService, private base64: any) {
    }

    public $onInit() {
        this.$log.debug("ApplicationDocuments");
        this.$log.debug(this.application);

        if (this.application.supportingDocuments.length > 0) {
            this.attachments = this.attachments.concat(this.application.supportingDocuments);
        }

        // Each prior course and units need to be looped since they can contain documents
        if (this.application.priorStudies.length > 0) {
            this.application.priorStudies.forEach((course) => {
                if (course.units.length > 0) {
                    course.units.forEach((unit) => {
                        if (unit.supportingDocuments.length > 0) {
                            this.attachments = this.attachments.concat(unit.supportingDocuments);
                        }
                    });
                }
            });
        }

        if (this.application.internalUseOnlyDocuments.length > 0) {
            this.attachments = this.attachments.concat(this.application.internalUseOnlyDocuments);
        }
    }

    /**
     * Generate a secure download URL that goes through the backend proxy.
     */
    public getDownloadUrl(attachment): string {
        return getSecureDownloadUrl(attachment, this.base64, this.application.id);
    }
}

export const ApplicationDocumentsComponent: IComponentOptions = {
    bindings: {
        application: "<"
    },
    controller: ApplicationDocumentsController,
    template: require("./application-documents.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/attachments/application-documents.component.ts